import { useRef, useState } from 'react';

import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';
import CustomImage from '../../fragments/custom-image/CustomImage';

import Button from '../../fragments/button/Button';

import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Controller,
  Parallax,
  Navigation,
  EffectCreative,
} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

export default function Quote({ block, index }) {
  const [controlledSwiper, setControlledSwiper] = useState(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const swiperRef = useRef(null);

  const quotes = block?.quotes ?? [];
  if (!block || quotes.length === 0) return null;

  const speed = 550;
  const isMultiple = quotes.length > 1;
  const hasImages = quotes.some((item) => item.image);

  const renderContent = (item) => (
    <div className="Quote-contentSlide">
      {item.quote && <blockquote className="h4">{item.quote}</blockquote>}
      {item.name && <p className="headingStrong">{item.name}</p>}
      {item.position && (
        <p className="text--size-s" style={{ marginTop: '0' }}>
          {item.position}
        </p>
      )}
    </div>
  );

  return (
    <ComponentWrapper
      block={block}
      className="Quote"
      padding={false}
      colorDynamic
    >
      <div className={'l-grid'}>
        <div className={`l-grid__col`}>
          <div className={`Quote-inner ${!isMultiple ? 'colorDynamicBg' : ''}`}>
            <div className={`Quote-top`}>
              <span className="quoteIcon"></span>

              {hasImages && (
                <div className="Quote-swiper">
                  {isMultiple ? (
                    <Swiper
                      className="Quote-imageSwiper"
                      modules={[Controller, Navigation, Parallax]}
                      speed={speed}
                      allowTouchMove={false}
                      onSwiper={setControlledSwiper}
                    >
                      {quotes.map((item, i) => (
                        <SwiperSlide key={i}>
                          {item.image && (
                            <div className="Quote-media">
                              <CustomImage
                                image={item.image}
                                fill={true}
                                swiperParallax={true}
                                sizes="(max-width: 768px) 60vw, 240px"
                              />
                            </div>
                          )}
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    quotes[0].image && (
                      <div className="Quote-media">
                        <CustomImage
                          image={quotes[0].image}
                          fill={true}
                          sizes="(max-width: 768px) 60vw, 240px"
                        />
                      </div>
                    )
                  )}
                </div>
              )}
            </div>

            <div className={`Quote-content`}>
              {isMultiple ? (
                <Swiper
                  // cssMode={true}
                  ref={swiperRef}
                  className="Quote-contentSwiper"
                  modules={[Controller, EffectCreative]}
                  speed={speed}
                  effect={'creative'}
                  allowTouchMove={false}
                  controller={{ control: controlledSwiper }}
                  onSlideChange={(swiper) => {
                    setIsBeginning(swiper.isBeginning);
                    setIsEnd(swiper.isEnd);
                  }}
                >
                  {quotes.map((item, i) => (
                    <SwiperSlide key={i}>{renderContent(item)}</SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                renderContent(quotes[0])
              )}

              {isMultiple && (
                <div className="Quote-controls">
                  <Button
                    className="button--icon"
                    aria-label="Previous Slide"
                    disabled={isBeginning}
                    onClick={() => swiperRef.current?.swiper?.slidePrev()}
                  />
                  <Button
                    className="button--icon"
                    aria-label="Next Slide"
                    disabled={isEnd}
                    onClick={() => swiperRef.current?.swiper?.slideNext()}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="Quote-mediaBackground">
          {block.imageBackground && (
            <CustomImage
              image={block.imageBackground}
              fill={true}
              parallax={true}
              desktopWidth={100}
            />
          )}
        </div>
      </div>
    </ComponentWrapper>
  );
}
